export default __webpack_public_path__ + "static/1589-6109d07b22592ad7efdc246c6fc8310a.gif";